import { jsx } from 'react/jsx-runtime';
import { Flex } from '../Flex/Flex.mjs';

const CarouselActions = ({ horizontal = true, spacing = 1, ...props }) => (jsx(Flex, { justifyContent: "center", gap: spacing, direction: horizontal ? 'row' : 'column', alignItems: horizontal ? 'center' : 'stretch', position: "absolute", width: "100%", bottom: 1, ...props }));

export { CarouselActions };
